// extracted by mini-css-extract-plugin
export default {"root":"AvatarPickerButton_root__HJZRa","label":"AvatarPickerButton_label__DC8yb","name":"AvatarPickerButton_name__jGkG6"};